/* Maison Felzo — JS du thème */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s) }
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)) }

  /* Menu mobile */
  var nav = $('#HeaderNav')
  $$('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { nav && nav.classList.toggle('is-open') })
  })

  /* Recherche */
  var sb = $('#SearchBar')
  var st = $('[data-search-toggle]')
  if (st && sb) st.addEventListener('click', function () {
    sb.hidden = !sb.hidden
    if (!sb.hidden) { var i = $('input', sb); i && i.focus() }
  })

  /* Compteur panier */
  function setCount(n) {
    var c = $('#CartCount')
    if (!c) return
    c.textContent = n > 0 ? n : ''
    c.setAttribute('data-n', n)
    $$('[data-cart-dot]').forEach(function (d) { d.hidden = !(n > 0) })
    $$('[data-cart-n]').forEach(function (d) { d.textContent = n })
    var fab = $('[data-cart-fab]')
    if (fab) {
      var was = fab.hidden
      fab.hidden = !(n > 0)
      var fn = $('[data-cart-fab-n]'); if (fn) fn.textContent = n
      if (n > 0) { fab.classList.remove('is-bump'); void fab.offsetWidth; fab.classList.add('is-bump') }
    }
  }

  /* Toast */
  var tt
  function toast(msg) {
    var t = $('#Toast')
    if (!t) return
    $('#ToastText').textContent = msg
    t.hidden = false
    clearTimeout(tt)
    tt = setTimeout(function () { t.hidden = true }, 4500)
  }

  /* Page produit */
  var form = $('#ProductForm')
  var dataEl = $('#ProductData')
  if (form && dataEl) {
    var data = JSON.parse(dataEl.textContent)
    var idInput = $('[name="id"]', form)
    var btn = $('#AddButton', form)
    var priceEl = $('#ProductPrice')
    var stockEl = $('#ProductStock')

    function selected() {
      return $$('.option', form).map(function (o) {
        var c = $('input:checked', o)
        return c ? c.value : null
      })
    }
    function currentVariant() {
      var sel = selected()
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] === null || o === sel[i] })
      })[0]
    }
    function update() {
      var v = currentVariant()
      if (!v) { btn.disabled = true; btn.textContent = 'Indisponible'; return }
      idInput.value = v.id
      priceEl.innerHTML = v.compare ? v.price + ' <s>' + v.compare + '</s>' : v.price
      priceEl.classList.toggle('price--sale', !!v.compare)
      btn.disabled = !v.available
      btn.textContent = v.available ? 'Ajouter au panier' : 'Vendu'
      if (stockEl) {
        stockEl.className = 'stock ' + (v.available ? 'stock--ok' : 'stock--out')
        stockEl.textContent = v.available ? 'Pièce disponible' : 'Cette pièce a trouvé preneur'
      }
      if (v.image) showImage(v.image)
      history.replaceState(null, '', '?variant=' + v.id)
    }
    $$('.option input', form).forEach(function (i) { i.addEventListener('change', update) })

    /* Galerie */
    var main = $('#GalleryMain img')
    function showImage(src) {
      document.dispatchEvent(new CustomEvent('felzo:variant-image', { detail: src }))
      if (!main) return
      var found = $$('[data-gallery-src]').filter(function (b) { return b.getAttribute('data-gallery-id') === String(src) })[0]
      if (found) found.click()
    }
    $$('[data-gallery-src]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-gallery-src')
        main.srcset = ''
        $$('[data-gallery-src]').forEach(function (x) { x.setAttribute('aria-current', 'false') })
        b.setAttribute('aria-current', 'true')
      })
    })

    /* Quantité */
    var qty = $('#Qty')
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10))
        qty.value = n
      })
    })

    /* Ajout au panier sans quitter la page */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return
      e.preventDefault()
      btn.disabled = true
      var old = btn.textContent
      btn.textContent = 'Ajout...'
      var legit = document.getElementById('LegitOpt')
      var addReq
      if (legit && legit.checked) {
        /* Pièce + certificat LegitGrails (+30 €) ajoutés ensemble */
        var qtyEl = document.getElementById('Qty')
        addReq = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(idInput.value, 10), quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 },
            { id: parseInt(legit.getAttribute('data-variant'), 10), quantity: 1, properties: { 'Pour la pièce': legit.getAttribute('data-piece') } }
          ] })
        })
      } else {
        addReq = fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      }
      addReq
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j } }) })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || 'Erreur')
          return fetch('/cart.js').then(function (r) { return r.json() })
        })
        .then(function (cart) { setCount(cart.item_count); toast('Ajouté au panier') })
        .catch(function (err) { toast(err.message) })
        .then(function () { btn.disabled = false; btn.textContent = old })
    })
  }

  /* Panier : quantité qui s'actualise toute seule */
  var cart = $('#CartForm')
  if (cart) {
    $$('[data-line-qty]', cart).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input', b.parentNode)
        inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-line-qty'), 10))
        cart.submit()
      })
    })
    $$('.qty input', cart).forEach(function (i) { i.addEventListener('change', function () { cart.submit() }) })
  }

  /* Adresses client */
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    $$('[data-address-form]').forEach(function (f) {
      var id = f.getAttribute('data-address-form')
      new Shopify.CountryProvinceSelector('AddressCountry_' + id, 'AddressProvince_' + id, {
        hideElement: 'AddressProvinceContainer_' + id
      })
    })
  }
  $$('[data-delete-address]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (confirm('Supprimer cette adresse ?') && window.Shopify && Shopify.postLink) {
        Shopify.postLink(b.getAttribute('data-delete-address'), { parameters: { _method: 'delete' } })
      }
    })
  })

  /* Mot de passe oublié */
  var rt = $('[data-recover-toggle]')
  if (rt) rt.addEventListener('click', function (e) {
    e.preventDefault()
    $('#LoginBox').hidden = !$('#LoginBox').hidden
    $('#RecoverBox').hidden = !$('#RecoverBox').hidden
  })
  if (location.hash === '#recover' && $('#LoginBox')) {
    $('#LoginBox').hidden = true
    $('#RecoverBox').hidden = false
  }
})()

/* Animations : apparition au défilement, header intelligent */
;(function () {
  var root = document.documentElement
  root.classList.add('js')
  var items = Array.prototype.slice.call(document.querySelectorAll('.section .section__head, .grid > *, .split > *, .trust__item, .article-card, .summary, .newsletter .container, .stat, .addr'))
  items.forEach(function (el, i) { el.classList.add('reveal'); el.style.setProperty('--d', ((i % 4) * 0.08) + 's') })
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target) } })
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    items.forEach(function (el) { io.observe(el) })
  } else items.forEach(function (el) { el.classList.add('is-in') })

  var h = document.querySelector('.header'), last = 0, hTick = false, sc = null, hid = null
  function headerTick() {
    hTick = false
    var y = Math.max(0, window.pageYOffset)
    var s = y > 24, hd = y > last && y > 240
    if (s !== sc) { sc = s; h.classList.toggle('is-scrolled', s) }
    if (hd !== hid) { hid = hd; h.classList.toggle('is-hidden', hd) }
    last = y
  }
  if (h) window.addEventListener('scroll', function () { if (!hTick) { hTick = true; requestAnimationFrame(headerTick) } }, { passive: true })
})()

/* Parallaxe douce de la bannière */
;(function () {
  var img = document.querySelector('.hero__img')
  /* Ordinateur uniquement : sur mobile (iOS surtout) la parallaxe saccade avec la barre d'adresse et le rebond du défilement */
  if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  if (!window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:1001px)').matches) return
  var pTick = false
  function par() {
    pTick = false
    var y = Math.max(0, window.pageYOffset)
    if (y < 900) img.style.transform = 'translate3d(0,' + (y * 0.25) + 'px,0) scale(' + (1 + y * 0.0002) + ')'
  }
  window.addEventListener('scroll', function () { if (!pTick) { pTick = true; requestAnimationFrame(par) } }, { passive: true })
})()
